import { BaseDataService } from "@bbwt/modules/data-service";

export abstract class XlsExportService extends BaseDataService {
    protected performDownload(fileName: string, blob: Blob): void {
        const url: string = window.URL.createObjectURL(blob);

        const downloadLink: HTMLAnchorElement = document.createElement("a");
        downloadLink.style.display = "none";
        downloadLink.href = url;

        document.body.appendChild(downloadLink);

        downloadLink.setAttribute("download", fileName + ".xlsx");
        downloadLink.click();
        downloadLink.remove();

        URL.revokeObjectURL(url);
    }
}